<template>
  <CurrencyInput
    :value="value"
    :auto-decimal-mode="true"
    :distraction-free="false"
    :currency="currency"
    locale="pt-BR"
    class="demo__currency-input form-control"
    @input="onInput"
    v-bind="$attrs"
  />
</template>

<script>
export default {
  name: "CurrencyInputComponent",
  inheritAttrs: false,

  props: {
    value: {
      type: Number,
      default: false,
    },
    currency: {
      type: String,
      default: "BRL",
    },
  },

  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>
